import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../../../src/utill/validation";
import { Row, Space } from "antd";
import axios from "axios";
import api from "../../../src/config.json";
import Table from "../../../src/Common/table";
import dateTime from "../../../src/utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../../../src/utill/Excelimport";
import Loading from "../../../src/utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
import { generateExcelFile } from "../../utill/download";

const RMMaster = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({ path: 'PartID', order: 'asc' });

  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Operation, setOperation] = useState({});
  const [componentList, setcomponentList] = useState([]);
  const [modelState, setmodelState] = useState(false);
  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([{Name:'Chemical',value:'Chemical'},{Name:'Carbon',value:'Carbon'},{Name:'Polymer',value:'Polymer'},{Name:'Oil',value:'Oil'},{Name:'Others',value:'Others'}]);

  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [PartName, setPartName] = useState("");
  const [PartNumber, setPartNumber] = useState("");
  const [Measurement, setMeasurement] = useState([]);

  

  const columns = [
    { path: "RM_Type", label: "Raw Material Type" },
    { path: "RM_ID", label: "Raw Material Id" },
    { path: "Description", label: "Description" },
    { path: "UnitOfMeasurement", label: "Unit Of Measurment" },

 
    {
      path: "createdAt",
      label: "Created Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      path: "updatedAt",
      label: "Last Updated Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      key: "update",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("StaticDataRights", RightName, "update")
          }
          onClick={() => {
            setOperation(user)
            setUpdate(user);
            setopStatus("update");
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
    // { key: 'view', content: user => <button onClick={() => onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    {
      key: "delete",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("StaticDataRights", RightName, "update")
          }
          onClick={() => onDelete(user)}
          className="btn btn-sm btn-danger"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      ),
    },
  ];

  useEffect(() => {
    if (opStatus == "update") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setOperation(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  useEffect(() => {

    Heading("Raw Material Master");
    // getCompundList();
    getToolList();
    getMeasurement();
  }, []);

  const getMeasurement = () => {
    axios
      .get(api.api + "Measurement")
      .then((result) => {
        const list = result.data.map((x) => ({Name: x.MeasurementUnit,value: x.MeasurementUnit}));
        setMeasurement(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getToolList = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
        setcomponentList(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const downloadPDF = async (qrCodeGroups, Operation) => {
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(
      `RmMaster.pdf`
    );
  };
  const A4Sheet = (QRCodeVisible, Operation) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    if (QRCodeVisible) {
      const totalStickers = Number(Operation.NumOfStickers);
      for (let i = 0; i < totalStickers; i += 1) {
        qrCodeGroups.push(
          [...Array(Math.min(1, totalStickers - i))].map((_, j) => i + j)
        );
      }
    }

    // Function to download the PDF

    return (
      <div>
        <Button
          type="primary"
          onClick={() => {
            downloadPDF(qrCodeGroups, Operation);
          }}
          style={{ marginBottom: "16px" }}
        >
          Download as PDF
        </Button>
        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter: "always" }}
            >
              {group.map((index) => (
                <div className="d-flex justify-content-center " key={index}>
                  <div className="p-5">
                    <QRCodeSVG level="M"
                      className="d-flex justify-content-center "
                      value={JSON.stringify(Operation)}
                      size={500}
                    />
                    <h3 className="bolder text-center">
                      {Operation.RM_Type}
                    </h3>
                    <h3 className="bolder text-center">{Operation.BatchNo}</h3>
                    <h3 className="bolder text-center">
                      {index + 1 + " / " + Operation.NumOfStickers}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };

  const handleSort = sortColumn => {
    if (componentList.length > 0) {
      const sorted = _.orderBy(componentList, [sortColumn.path], [sortColumn.order]);
      setSortColumn(sortColumn)
      setcomponentList(sorted)
    }
  }

  const schema = {
    RM_Type: joi.string().required(),
    RM_ID: joi.string().required(),
    Description: joi.string().required(),
    UnitOfMeasurement: joi.string().required(),
    Enable: joi.boolean(),

    _id: joi.string(),
  };

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;
if(name ==='UnitOfMeasurement'){
  setOperation((prev) => ({
    ...prev,
    [name]: value,
  }));
}else if(name ==='RM_Type'){
  setOperation((prev) => ({
    ...prev,
    [name]: value,
  }));
}else{
  setOperation((prev) => ({
    ...prev,
    [name]: value,
  }));
}
   
  };

  const handleOnChange1 = (e) => {
    const { value } = e.currentTarget;

    setPartName(value); // Merges the new value with the previous string
  };
  const handleOnChange2 = (e) => {
    const { value } = e.currentTarget;

    setPartNumber(value); // Merges the new value with the previous string
  };
  const handleOnAdd = () => {
    const test = { ...Operation };
    if (PartName.length > 0) {
      test.PartName = [...(test.PartName || []), PartName];
      setPartName("");
      setOperation(test);
    }
    else {

      swal('Can Not Add Blank Part Name')
    }
    // Add PartName (string) to the array in test.PartName

  };
  const handleOnAdd1 = () => {
    const test = { ...Operation };
    if (PartNumber.length > 0) {
      test.PartNumber = [...(test.PartNumber || []), PartNumber];
      setPartNumber("");
      setOperation(test);
    }
    else {

      swal('Can Not Add Blank Part Name')
    }
    // Add PartName (string) to the array in test.PartName

  };
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };
 
  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "RMMaster/" + data._id, { data: data })
          .then((result) => {
            getToolList();
            swal('Deleted  Successfully')

          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };

  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data) => {
    // return
    const checksheet = { ...data };
    delete checksheet.__v
    delete checksheet.createdAt
    delete checksheet.updatedAt
    const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);
    //   return;
    // }
    setLoader(true);
    if (opStatus == "update") {
      axios
        .patch(api.api + "RMMaster/" + Update._id, checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          getToolList();
          setQRCodeVisible(true);

          handleCloseModel();
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "RMMaster", checksheet)
        .then((result) => {
          swal("Data Saved Successfully");
          getToolList();
          handleCloseModel();
          setQRCodeVisible(true);

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        className="custom-modal1"
        size={size}
        show={modelState}
        onHide={handleHideModel}
        backdrop={'static'}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Raw Material Master</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Operation${id}`}> */}
          <Row className="">
            {/* <Col sm={3}>
              <div className="form-group form-group-sm">
                <label htmlFor="operationRejectionCost">Batch No</label>
                <input
                  required
                  onChange={handleOnChange}
                  style={{ width: "100%" }}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm"
                  type="text"
                  // min="0"
                  name="BatchNo"
                  value={Operation.BatchNo}
                />
                {errors.BatchNo && <div className="alert small alert-danger">{errors['BatchNo']}</div>}
              </div>
            </Col>
           */}
            
            <Col sm={12}>
              <div className="form-group mt-2">
                <label htmlFor="operationRejectionCost" className="fw-bold">Raw Material Type</label>
                <AntdSelect
                 
                  placeholder="Raw Material Type"
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "RM_Type", value: value },
                    });
                  }}
                  value={Operation.RM_Type || []}
                  style={{ width: "100%" }}
                >
                  {templateList.map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                {errors.RM_Type && (
                  <div className="alert small alert-danger">
                    {errors["RM_Type"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group form-group-sm d-flex flex-column">
                <label htmlFor="operationRejectionCost " className="fw-bold">  Raw Material Id  </label>
                <input
                  required
                  onChange={handleOnChange}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm w-100"
                  type="text"
                  name="RM_ID"
                  value={Operation.RM_ID}
                  placeholder="Enter Raw Material Id"

                />
                {errors.RM_ID && (
                  <div className="alert small alert-danger">
                    {errors["RM_ID"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group form-group-sm d-flex flex-column">
                <label htmlFor="operationRejectionCost " className="fw-bold">  Description </label>
                <input
                  required
                  onChange={handleOnChange}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm w-100"
                  type="text"
                  name="Description"
                  value={Operation.Description}
                  placeholder="Enter Description"

                />
                {errors.Description && (
                  <div className="alert small alert-danger">
                    {errors["Description"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2">
                <label htmlFor="operationRejectionCost" className="fw-bold">Unit Of Measurment</label>
                <AntdSelect
                 
                  placeholder="Unit Of Measurment"
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "UnitOfMeasurement", value: value },
                    });
                  }}
                  value={Operation.UnitOfMeasurement || []}
                  style={{ width: "100%" }}
                >
                  {Measurement.map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                {errors.UnitOfMeasurement && (
                  <div className="alert small alert-danger">
                    {errors["UnitOfMeasurement"]}
                  </div>
                )}
              </div>
            </Col>
        
          </Row>
         
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const error = validateCheckCheckPoints(rows);
              if (error.IsError) {
                swal("ERROR", error.message.join(", "), { dangerMode: true });
              } else {
                handelSaveData(Operation);
              }
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex float-left mb-2">
        {
          <button
            disabled={!getRightsForAccess("StaticDataRights", RightName, "write")}
            className="btn-sm btn-success ml-2 mt-2"
            onClick={() => {
              setmodelState(true);
              setOperation({});
              setUpdate({});
              setSelectedTemplate({});
            }}
          >
            Create New Raw Material
          </button>
        }
        {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button>  */}
        {getRightsForAccess('StaticDataRights', RightName, "write") && <Excelimport getToolList={getToolList} API={'RMMaster'} handelUpdate={()=>getToolList()}/>}
      </div>

      <div className="">
            <button   onClick={() => handleDownloadExcel("RMMasterTemplate")}className="btn-sm btn-primary ml-2 mt-2">Download Template</button>
        </div>
        <div style={{display:'none'}}>
          <table >
            <thead>
              <tr class>
             
                <th >RM_Type</th>
                <th >RM_ID</th>
                <th >Description</th>
                <th >UnitOfMeasurement</th>

              </tr>
            </thead>
          </table>
        </div>
      {componentList.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
        id="RMMasterTemplate"
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={componentList}
        />
      )}
    </>
  );
};

export default RMMaster;
